// Cardápio 1-opção (M2b OnDiet Next, 2026-07-09). Default OFF.
// OFF = lista de 3 opções atual, byte-a-byte. ON = OP1 em destaque +
// alternativas em disclosure (CategoryOptionsV2). Display-only — o fluxo
// de substituição não muda. Liga via VITE_FEATURE_CARDAPIO_V2=true no build.
export const CARDAPIO_V2_ENABLED = import.meta.env.VITE_FEATURE_CARDAPIO_V2 === "true";

// Estrutura do Dia (motor v2 — Fase D do OnDiet Next, 2026-07-14). Default OFF.
// OFF = rota /estrutura-do-dia não existe (produção idêntica a hoje). ON =
// tela de ajuste da estrutura (% por refeição, categorias, frutas em unidades)
// rodando a MESMA lógica do alocador do backend (src/lib/engineV2/, golden
// tests espelham execution/engine_v2/alocador.py). Estreia no funil trial.
export const ESTRUTURA_DIA_ENABLED = import.meta.env.VITE_FEATURE_ESTRUTURA_DIA === "true";

// Sistema Vivo / Plano Vivo (conceito 01, motor v2). Default OFF: /home continua
// usando o Home atual, nenhum request para /api/v2/plano acontece e o chunk do
// Sistema Vivo nem carrega (o lazy() só resolve quando a rota renderiza).
// ON = /home passa pelo PlanoV2HomeGate, que só troca a tela depois de um 200 do
// endpoint; 404, erro e timeout continuam caindo no Home legado.
// ⚠️ INERTE desde o sunset do trilho legado (2026-08-21). Nenhum arquivo de
// producao le mais este valor: os dois ternarios do App.tsx que o consumiam
// saiam junto com `pages/Home.tsx`. Desligar a flag NAO faz rollback — nao ha
// mais tela legada para cair. Remover a constante e o ARG do Dockerfile e PR
// proprio (arquivo protegido).
export const DIETA_V2_ENABLED = import.meta.env.VITE_FEATURE_DIETA_V2 === "true";

// A Anamnese V2 (telas em /anamnese/) é o fluxo OFICIAL de coleta desde 2026-06 — SEM feature flag
// (a coleta via chat com a Lia foi descontinuada/arquivada). O gate em Home.tsx redireciona todo
// usuário em coleta_em_andamento pro /anamnese/ incondicionalmente.

// Selo clínico da versão efetiva. Rollout manual; OFF por padrão.
export const REVISAO_PLANO_ENABLED = import.meta.env.VITE_FEATURE_REVISAO_PLANO === "true";
// Coleta de motivo na tela de exclusão. A resposta fica em memória e só segue
// junto da confirmação final por OTP; não é enviada ao endpoint legado de saída.
export const EXIT_FEEDBACK_ENABLED = true;
